import { FillExtrusionLayerSpecification } from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxSourceIds,
  AcresMapboxVectorSourceLayerIds,
} from '..';

export const threeDBuildingsLayer: FillExtrusionLayerSpecification = {
  id: AcresMapboxLayerIds.THREE_D_BUILDINGS,
  minzoom: 13,
  paint: {
    'fill-extrusion-base': [
      'interpolate',
      ['linear'],
      ['zoom'],
      13,
      0,
      16,
      ['get', 'render_min_height'],
    ],
    'fill-extrusion-color': '#87919C', // Gray 50
    'fill-extrusion-height': [
      'interpolate',
      ['linear'],
      ['zoom'],
      13,
      0,
      16,
      ['get', 'render_height'],
    ],
    'fill-extrusion-opacity': 0.75,
  },
  source: AcresMapboxSourceIds.BUILDINGS,
  'source-layer': AcresMapboxVectorSourceLayerIds.BUILDING,
  type: 'fill-extrusion',
};
